<template>
  <v-dialog
    v-model="show_vendor_directory_modal"
    scrollable
    :max-width="maxWidth"
  >
    <v-card tile class="rounded-lg">
      <v-toolbar dark flat color="primary" dense>
        <v-toolbar-title>Exibitor Directory</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-subtitle class="pa-1">
        <v-row dense>
          <v-col cols="1" align-self="center" class="text-right">
            <b>Search By</b>
          </v-col>
          <v-col cols="3">
            <v-text-field
              outlined
              placeholder="Vendor Name"
              hide-details
              dense
              append-icon="mdi-magnify"
              v-model="search_vendor"
              v-debounce:300ms="searchVendor"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="2">
            <v-select
              outlined
              dense
              :items="items"
              placeholder="Category"
              hide-details
            ></v-select>
          </v-col> -->
        </v-row>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(vendor, index) in vendor_list" :key="index" :to="'/vendor/'+vendor.vendor_id">
            <v-list-item-action>
              <v-img :src="vendor.profile_pic" contain height="120" max-width="220"></v-img>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ vendor.company_name }}</v-list-item-title>
              <v-list-item-subtitle v-text="stripHtml(vendor.comapny_desc)"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-img :src="vendor.sponsortype.sponsor_logo" max-width="70"></v-img>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "VendorDirectory",
  data() {
    return {
      dialog: false,
      search_vendor: "",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    };
  },
  watch: {
    show_vendor_directory_modal(value) {
      if (value) {
        this.fetchVendor();
      }
    },
  },
  computed: {
    ...mapState("vendor_directory", [
      "show_vendor_directory_modal",
      "vendor_list",
    ]),
    ...mapState("utils", ["maxWidth"]),
  },
  methods: {
    ...mapActions("vendor_directory", ["fetchVendor"]),
    ...mapMutations("vendor_directory", ["setVendorData"]),
    showVendorDirectory() {
      this.setVendorData({
        key: "show_vendor_directory_modal",
        data: true,
      });
    },
    searchVendor() {
      this.setVendorData({
        key: "search_vendor",
        data: this.search_vendor,
      });
      this.fetchVendor();
    },
    closePopup() {
      this.setVendorData({
        key: "show_vendor_directory_modal",
        data: false,
      });
    },
    stripHtml(html)
    {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }
  },
  mounted: function () {
    this.fetchVendor();
  },
};
</script>